import { render } from "./IndividualList.vue?vue&type=template&id=c0822510&scoped=true"
import script from "./IndividualList.vue?vue&type=script&lang=js"
export * from "./IndividualList.vue?vue&type=script&lang=js"

import "./IndividualList.vue?vue&type=style&index=0&id=c0822510&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0822510"]])

export default __exports__